const schema = () => ({
  type: 'object',
  required: [],
  properties: {
    category_id: {
      type: 'string',
      title: 'دسته‌بندی',
    },
  },
});

export default schema;
